import { render, staticRenderFns } from "./new_label.vue?vue&type=template&id=6e3414e2&scoped=true&"
import script from "./new_label.vue?vue&type=script&lang=js&"
export * from "./new_label.vue?vue&type=script&lang=js&"
import style0 from "./new_label.vue?vue&type=style&index=0&id=6e3414e2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3414e2",
  null
  
)

export default component.exports